module.exports = __webpack_public_path__ + "img/place_car.34578d57.png";